import { Component, Inject, OnInit } from '@angular/core';
import { IFile } from '../../models/products.models';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-files',
  templateUrl: './edit-files.component.html',
  styleUrls: ['./edit-files.component.scss']
})
export class EditFilesComponent implements OnInit {
  selectedFiles: IFile[] = []; 
  
  constructor(
    public dialogRef: MatDialogRef<EditFilesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { files: IFile[] }
  ) {}

  ngOnInit(): void {
    if (this.data?.files && this.data.files.length) {
      this.selectedFiles = [...this.data.files];
    }
    console.log('selectfiles', this.selectedFiles);
  }

  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    Array.from(input.files).forEach((file: File) => {

      const reader = new FileReader();
      reader.onload = () => {
        const base64Data = reader.result as string;
        this.selectedFiles.push({
          data: base64Data.split(',')[1],
          filename: file.name,
          content_type: file.type,
        });
      };
      reader.readAsDataURL(file);
    });
  }

  removeFile(index: number, arrayType: 'selectedFiles'): void {
      this.selectedFiles.splice(index, 1);
  }

  save(): void {
  this.dialogRef.close(this.selectedFiles);
  }

  closed(): void {
    this.dialogRef.close();
  }

}
